module.exports = __webpack_public_path__ + "media/images/menu/solar_system_simulator-2143046c01bb50e370a540c6d8cf65f4.jpg";